import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-beauty-biz-form.component.scss';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from "jquery";
import "bootstrap-datepicker";
var FormItemBeautyBizForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBeautyBizForm, _super);
    function FormItemBeautyBizForm(element) {
        var _this = _super.call(this, element) || this;
        //prevent multi-select re-init + listener stacking
        _this._multiSelectInited = false;
        _this._onDocPointerDown = null;
        _this._onDocKeyDown = null;
        return _this;
    }
    FormItemBeautyBizForm.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js_submit-button"));
        if (this.applyForm) {
            this.displayLoader = this.applyForm.querySelector(".form-container__loader");
            this.displayFields = this.applyForm.querySelector(".form-container__fields");
            this.displaySuccess = this.applyForm.querySelector(".form-container__success");
            this.displayFail = this.applyForm.querySelector(".form-container__error");
        }
        this.containerModal = this.element.closest('.form-item-beauty-biz-form');
        this.closeButton = this.containerModal ? this.containerModal.querySelector('.js-apply-now-modal-close') : null;
        this.formDatePicker = this.element.querySelector('.js-date-picker');
        this.formTimePicker = this.element.querySelector('.js-time-picker');
        this.identificationSelection = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.initFieldLengths();
        this.bindBusinessRegFormatting();
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        //FIX: SMS selectors must target sms classes
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-sms");
        //FIX: Email selectors must target email classes
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingEmailTextArea = this.element.querySelector(".data-sharing-email");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        if ((typeof dataLayer != 'undefined')) {
            dataLayer.application.applicationName = "callmeback BusinessSolutions";
        }
        this.publicHolidays = [
            '2026/01/01',
            '2026/03/21',
            '2026/04/03',
            '2026/04/06',
            '2026/04/27',
            '2026/05/01',
            '2026/06/16',
            '2026/08/09',
            '2026/08/10',
            '2026/09/24',
            '2026/12/16',
            '2026/12/25',
            '2026/12/26',
        ];
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        this.populateDatePicker();
        this.initMultiSelect();
    };
    // =========================
    // Business Reg formatting
    // Format: YYYY/NNNNNN/NN
    // =========================
    FormItemBeautyBizForm.prototype.formatBusinessRegLive = function (value) {
        if (!value)
            return '';
        var v = value.replace(/[^\d]/g, '');
        if (v.length > 12)
            v = v.substring(0, 12);
        if (v.length > 4)
            v = v.substring(0, 4) + '/' + v.substring(4);
        if (v.length > 11)
            v = v.substring(0, 11) + '/' + v.substring(11);
        return v.substring(0, 14);
    };
    FormItemBeautyBizForm.prototype.formatBusinessRegOnBlur = function (value) {
        if (!value)
            return '';
        var digits = value.replace(/[^\d]/g, '');
        if (digits.length < 12)
            return '';
        var y = digits.substring(0, 4);
        var mid = digits.substring(4, 10);
        var end = digits.substring(10, 12);
        return y + "/" + mid + "/" + end;
    };
    FormItemBeautyBizForm.prototype.bindBusinessRegFormatting = function () {
        var _this = this;
        var field = this.applyForm ? this.applyForm.querySelector("input[name=\"business-reg-number\"]") : null;
        if (!field)
            return;
        field.addEventListener('input', function (e) {
            if (e && (e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward'))
                return;
            field.value = _this.formatBusinessRegLive(field.value);
        });
        field.addEventListener('blur', function () {
            var formatted = _this.formatBusinessRegOnBlur(field.value);
            if (formatted)
                field.value = formatted;
            _this.validationService.validateBlur(field);
        });
    };
    // =========================
    // Solutions validation
    // =========================
    FormItemBeautyBizForm.prototype.clearSolutionsError = function (form) {
        var multiSelect = form.querySelector('.js-multi-select');
        if (!multiSelect)
            return;
        var control = multiSelect.querySelector('.js-multi-select-toggle');
        if (!control)
            return;
        control.classList.remove('form__input--error');
        var groupEl = control.closest('.form__group');
        if (groupEl) {
            groupEl.classList.remove('form__group--error');
            var msg = groupEl.querySelector('.form__message--error, .form__message.form__message--error');
            if (msg)
                msg.remove();
        }
    };
    FormItemBeautyBizForm.prototype.showSolutionsError = function (form) {
        var multiSelect = form.querySelector('.js-multi-select');
        if (!multiSelect)
            return;
        var control = multiSelect.querySelector('.js-multi-select-toggle');
        if (!control)
            return;
        control.classList.add('form__input--error');
        var groupEl = control.closest('.form__group');
        if (groupEl)
            groupEl.classList.add('form__group--error');
        //same rendering style as other inputs (Business Name etc.)
        this.validationService.addErrorMessage(control, ['Please select at least one bundled solution']);
    };
    FormItemBeautyBizForm.prototype.validateSolutions = function (form) {
        var solutionCheckboxes = Array.from(form.querySelectorAll("input[name=\"solutions[]\"]"));
        if (solutionCheckboxes.length === 0)
            return true;
        var hasSelected = solutionCheckboxes.some(function (c) { return c.checked; });
        if (hasSelected) {
            this.clearSolutionsError(form);
            return true;
        }
        this.showSolutionsError(form);
        return false;
    };
    FormItemBeautyBizForm.prototype.populateDatePicker = function () {
        var _this = this;
        this._startDate = this.validateDate();
        var nextYear = new Date().getFullYear() + 1;
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker({
                startDate: this._startDate,
                format: 'yyyy/mm/dd',
                daysOfWeekDisabled: [0, 6],
                datesDisabled: this.publicHolidays,
                endDate: new Date(nextYear, 11, 31),
            });
            $(this.formDatePicker).change(function () {
                _this.formDatePicker.dispatchEvent(new Event('blur', {}));
            });
        }
    };
    FormItemBeautyBizForm.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        if (item && item.options) {
            var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
            for (var i = item.options.length - 1; i >= 0; i--) {
                if (item.options[i].value !== 'Anytime') {
                    if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                        item.options[i].disabled = true;
                    }
                    else if (_enabledOptions === true) {
                        item.options[i].disabled = false;
                    }
                }
            }
        }
        return _currentDateTime;
    };
    FormItemBeautyBizForm.prototype.bindEvents = function () {
        var _this = this;
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener('change', function (event) {
                _this.validateDate(event.target);
            });
        }
        var solutionCheckboxes = this.applyForm ? Array.from(this.applyForm.querySelectorAll("input[name=\"solutions[]\"]")) : [];
        if (solutionCheckboxes.length) {
            solutionCheckboxes.forEach(function (cb) { return cb.addEventListener('change', function () { return _this.validateSolutions(_this.applyForm); }); });
            var multiSelectRoot = this.element.querySelector('.js-multi-select');
            if (multiSelectRoot) {
                multiSelectRoot.addEventListener('focusout', function () {
                    _this.validateSolutions(_this.applyForm);
                });
            }
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                if (_this.showMoreBtn)
                    _this.showMoreBtn.removeAttribute('hidden');
                if (_this.dataPrivacyDetailArea)
                    _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                if (_this.showLessBtn)
                    _this.showLessBtn.removeAttribute('hidden');
                if (_this.dataPrivacyDetailArea)
                    _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn && this.dataSharingGroupShowBtn && this.dataSharingGroupTextArea) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn && this.dataSharing3rdPartyShowBtn && this.dataSharing3rdPartyTextArea) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn && this.dataSharingBoardersHideBtn && this.dataSharingBoardersTextArea) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingTeleSaleShowBtn && this.dataSharingTeleSaleHideBtn && this.dataSharingTeleSaleTextArea) {
            this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
                _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
                _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
            });
            this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
                _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
                _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingSmsShowBtn && this.dataSharingSmsHideBtn && this.dataSharingSmsTextArea) {
            this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingSmsTextArea.removeAttribute("hidden");
                _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
                _this.dataSharingSmsHideBtn.removeAttribute("hidden");
            });
            this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
                _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
                _this.dataSharingSmsShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingEmailShowBtn && this.dataSharingEmailHideBtn && this.dataSharingEmailTextArea) {
            this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingEmailTextArea.removeAttribute("hidden");
                _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
                _this.dataSharingEmailHideBtn.removeAttribute("hidden");
            });
            this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
                _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
                _this.dataSharingEmailShowBtn.removeAttribute("hidden");
            });
        }
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var turnoverField = _form.querySelector("input[name=\"annual-turnover\"]");
            if (turnoverField) {
                _this.validateTurnoverField(turnoverField);
            }
            _this.validateSolutions(_form);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
            else {
                window.scroll({ top: 0, behavior: "smooth" });
            }
        }); });
        if (this.closeButton)
            this.closeButton.addEventListener('click', function () { return _this.closeForm(); });
        if (this.doneSubmit)
            this.doneSubmit.addEventListener('click', function () { return _this.closeForm(); });
        if (this.applyForm) {
            this.applyForm.addEventListener("custom_form_reset_event", function () {
                _this.resetForm();
                _this.clearSolutionsError(_this.applyForm);
            }, false);
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select"));
            _formFields.forEach(function (pEement) {
                pEement.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
            });
            var turnoverField_1 = this.applyForm
                ? this.applyForm.querySelector('input[name="annual-turnover"]')
                : null;
            if (turnoverField_1) {
                turnoverField_1.addEventListener('blur', function () {
                    _this.validateTurnoverField(turnoverField_1);
                });
            }
        }
    };
    FormItemBeautyBizForm.prototype.initFieldLengths = function () {
        var _firstName = this.applyForm ? this.applyForm.querySelector("input[name=firstName]") : null;
        if (_firstName)
            _firstName.setAttribute("maxlength", "80");
        var _surname = this.applyForm ? this.applyForm.querySelector("input[name=surname]") : null;
        if (_surname)
            _surname.setAttribute("maxlength", "80");
        var _contactNumber = this.applyForm ? this.applyForm.querySelector("input[name=contactNo]") : null;
        if (_contactNumber)
            _contactNumber.setAttribute("maxlength", "10");
        var _reg = this.applyForm ? this.applyForm.querySelector("input[name=\"business-reg-number\"]") : null;
        if (_reg) {
            _reg.setAttribute('maxlength', '14');
            _reg.setAttribute('inputmode', 'numeric');
        }
    };
    FormItemBeautyBizForm.prototype.validSAContact = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^0[0-9]\d{8}$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    FormItemBeautyBizForm.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.remove("active");
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displayFail.classList.remove("active");
        this.displayFail.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.add("active");
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.add("active");
                this.displaySuccess.classList.remove("hidden");
                break;
            case "fail":
                this.displayFail.classList.add("active");
                this.displayFail.classList.remove("hidden");
                break;
            default:
                this.displayLoader.classList.add("active");
                this.displayLoader.classList.remove("hidden");
                break;
        }
    };
    FormItemBeautyBizForm.prototype.closeForm = function () {
        var baseUrl = document.querySelector('input[name=productPage]');
        window.location.href = (baseUrl && baseUrl.value) ? baseUrl.value : '/southafrica/business';
    };
    FormItemBeautyBizForm.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            this.showDisplayView("fields");
        }
    };
    FormItemBeautyBizForm.prototype.submitForm = function (form) {
        var _this = this;
        var analyticsService = new AnalyticsService();
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNo]");
        var _email = this.applyForm.querySelector("input[name=emailAddress]");
        var _recipient = this.applyForm.querySelector("input[name=recipient]");
        var _mailBoxEmail = this.applyForm.querySelector("input[name=email]");
        var _popiConsent = this.applyForm.querySelector("input[name=popia-consent]");
        var _businessName = this.applyForm.querySelector("input[name=businessName]");
        var _registrationNumber = this.applyForm.querySelector("input[name=business-reg-number]");
        var _turnOver = this.applyForm.querySelector("input[name=annual-turnover]");
        var _province = this.applyForm.querySelector("select[name=province]");
        var solutionCheckboxes = Array.from(this.applyForm.querySelectorAll("input[name=\"solutions[]\"]"));
        var selectedSolutions = solutionCheckboxes.filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
        var errors = [];
        if (_contactNumber && _contactNumber.value.length != 10) {
            errors.push('South African contact numbers are 10 digits');
        }
        if (_contactNumber && !this.validSAContact(_contactNumber)) {
            errors.push('This contact number is invalid');
        }
        if (selectedSolutions.length === 0) {
            errors.push('Please select at least one bundled solution');
        }
        if (errors.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            var contactErrors = errors.filter(function (e) { return e.toLowerCase().indexOf('contact') !== -1; });
            if (_contactNumber && contactErrors.length)
                this.validationService.addErrorMessage(_contactNumber, contactErrors);
            if (selectedSolutions.length === 0) {
                this.showSolutionsError(form);
            }
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        if (_turnOver && !this.validateTurnoverField(_turnOver)) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        if (!this.validateSolutions(form)) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        var _postData = {
            subject: "Beauty Boss Bundle Business Solutions call me back",
            product: "Beauty Boss Bundle",
            firstName: (_firstName ? _firstName.value : ""),
            surname: (_surname ? _surname.value : ""),
            emailAddress: (_email ? _email.value : ""),
            email: (_recipient ? _recipient.value : ""),
            recipient: (_mailBoxEmail ? _mailBoxEmail.value : ""),
            contactNo: (_contactNumber ? _contactNumber.value : ""),
            businessName: (_businessName ? _businessName.value : ""),
            registrationNumber: (_registrationNumber ? _registrationNumber.value : ""),
            solutions: selectedSolutions.join(': '),
            province: (_province ? _province.value : ""),
            annualTurnOver: (_turnOver ? _turnOver.value : ""),
            dataPrivacyConsent: ((_popiConsent && _popiConsent.checked) ? "YES" : "NO"),
            dataSharingGroup: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-group'),
            dataSharing3rdParty: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-3rd-party'),
            dataSharingBoarders: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-boarders'),
            dataSharingTelesale: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-telesale'),
            dataSharingEmail: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-email'),
            dataSharingSms: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-sms'),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/beauty-biz-lead";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            var _response = response.data;
            if (_response.toString().includes('invalid')) {
                analyticsService.dtmFormComplete("complete", "false");
                _this.showDisplayView("fail");
            }
            else {
                analyticsService.dtmFormComplete("complete", "true");
                _this.showDisplayView("success");
                window.scroll({ top: 0, behavior: "smooth" });
            }
        }).catch(function () {
            analyticsService.dtmFormComplete("complete", "false");
            _this.showDisplayView("fail");
        });
    };
    // =========================
    //  Multi-select (stable)
    // =========================
    FormItemBeautyBizForm.prototype.initMultiSelect = function () {
        if (this._multiSelectInited)
            return;
        this._multiSelectInited = true;
        var multiSelect = this.element.querySelector('.js-multi-select');
        if (!multiSelect)
            return;
        var toggle = multiSelect.querySelector('.js-multi-select-toggle');
        var placeholder = multiSelect.querySelector('.multi-select__placeholder');
        var dropdown = multiSelect.querySelector('.multi-select__dropdown');
        var checkboxes = Array.from(multiSelect.querySelectorAll('input[type="checkbox"]'));
        if (!toggle || !placeholder || !dropdown)
            return;
        var countEl = multiSelect.querySelector('.multi-select__count');
        if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'multi-select__count';
            countEl.setAttribute('hidden', 'true');
            toggle.appendChild(countEl);
        }
        var updateLabel = function () {
            var selected = checkboxes.filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
            if (selected.length === 0) {
                placeholder.textContent = 'Select bundled solution';
                placeholder.removeAttribute('title');
                countEl.setAttribute('hidden', 'true');
                countEl.textContent = '';
                return;
            }
            if (selected.length <= 2) {
                placeholder.textContent = selected.join(', ');
                placeholder.setAttribute('title', selected.join(', '));
                countEl.setAttribute('hidden', 'true');
                countEl.textContent = '';
                return;
            }
            placeholder.textContent = selected[0] + ', ' + selected[1];
            placeholder.setAttribute('title', selected.join(', '));
            countEl.textContent = selected.length + ' selected';
            countEl.removeAttribute('hidden');
        };
        var close = function () { return multiSelect.classList.remove('is-open'); };
        var toggleOpen = function () { return multiSelect.classList.toggle('is-open'); };
        if (this._onDocPointerDown)
            document.removeEventListener('pointerdown', this._onDocPointerDown, true);
        if (this._onDocKeyDown)
            document.removeEventListener('keydown', this._onDocKeyDown, true);
        this._onDocPointerDown = function (e) {
            if (!multiSelect.contains(e.target))
                close();
        };
        document.addEventListener('pointerdown', this._onDocPointerDown, true);
        this._onDocKeyDown = function (e) {
            if (e.key === 'Escape')
                close();
        };
        document.addEventListener('keydown', this._onDocKeyDown, true);
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            toggleOpen();
        });
        dropdown.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        checkboxes.forEach(function (cb) { return cb.addEventListener('change', function () {
            updateLabel();
        }); });
        updateLabel();
    };
    FormItemBeautyBizForm.prototype.validateTurnoverField = function (field) {
        var raw = field.value;
        // remove old validation error first (prevents stacking)
        var group = field.closest('.form__group');
        if (group) {
            group.classList.remove('form__group--error');
            var msg = group.querySelector('.form__message--error');
            if (msg)
                msg.remove();
        }
        if (raw === '' || raw === null || raw === undefined) {
            this.validationService.addErrorMessage(field, ['Annual turnover is required']);
            return false;
        }
        var n = Number(raw);
        if (n === 0) {
            return true;
        }
        if (n < 0) {
            this.validationService.addErrorMessage(field, ['Annual turnover must be 0 or more']);
            return false;
        }
        return true;
    };
    return FormItemBeautyBizForm;
}(Base));
export { FormItemBeautyBizForm };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-beauty-biz-form/form-item-beauty-biz-form.component.ts
// module id = 1123
// module chunks = 0